var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcGitColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.49 39.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f1502f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_git_colored") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.75,23,26.51,5.74a2.54,2.54,0,0,0-3.59,0L19.34,9.32l4.54,4.55a3,3,0,0,1,3.82,3.85l4.38,4.37a3,3,0,1,1-1.81,1.71l-4.09-4.08V30.46A2.93,2.93,0,0,1,27,31a3,3,0,1,1-4.28,0,3.11,3.11,0,0,1,1-.66V19.53a3.11,3.11,0,0,1-1-.66,3,3,0,0,1-.65-3.31l-4.47-4.48L5.76,22.9a2.53,2.53,0,0,0,0,3.6L23,43.74a2.54,2.54,0,0,0,3.59,0L43.75,26.58A2.55,2.55,0,0,0,43.75,23Z",
    transform: "translate(-5.01 -5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGitColored);
export default __webpack_public_path__ + "static/media/ic_git_colored.6666a64ce4bab624b3ea8e69535859ec.svg";
export { ForwardRef as ReactComponent };